import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { procedures } from '../data/procedures';
export function Procedures() {
  const [featured, ...rest] = procedures;
  return <section id="procedures" className="bg-sand py-20 lg:py-28" data-id="element-102" data-mp="1fnpois6mrlf7">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-103" data-mp="1fpam6qo8rkha">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-104" data-mp="1ax10jmu5t6kt">
          <div className="max-w-2xl" data-id="element-105" data-mp="1pldw4ipc4nes">
            <p className="text-[0.65rem] uppercase tracking-overline text-champagne-dark" data-id="element-106" data-mp="1pkc7tcjb64f4">
              Surgical
            </p>
            <h2 className="mt-5 text-3xl font-light leading-[1.15] tracking-[-0.02em] text-ink sm:text-[2.75rem]" data-id="element-107" data-mp="1ymv8pr3ja6yq">
              Popular procedures
            </h2>
          </div>
          <a href="#consultation" className="whitespace-nowrap text-xs uppercase tracking-overline text-ink underline decoration-champagne decoration-1 underline-offset-[6px] transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-108" data-mp="1tlo05ptkh3r0">
            View all procedures
          </a>
        </div>

        <div className="mt-12 grid gap-8 lg:mt-16 lg:grid-cols-3 lg:gap-10" data-id="element-109" data-mp="3ls11qwur9nwb">
          <article className="group flex flex-col bg-white lg:col-span-2 lg:flex-row" data-id="element-110" data-mp="3qrng59mbla6p">
            <div className="overflow-hidden lg:w-1/2" data-id="element-111" data-mp="3qpst9prhn7zz">
              <img src={featured.image} alt={featured.name} className="h-64 w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.03] sm:h-80 lg:h-full" data-id="element-112" data-mp="3vjf5xhxnjbvs" />
            </div>
            <div className="flex flex-1 flex-col p-8 lg:p-10" data-id="element-113" data-mp="dd0k6wt55xmu">
              <span className="text-[0.6rem] uppercase tracking-overline text-champagne-dark" data-id="element-114" data-mp="ddis4qp620al">
                {featured.category} · Most requested
              </span>
              <h3 className="mt-5 text-2xl font-light tracking-[-0.01em] text-ink sm:text-[2rem]" data-id="element-115" data-mp="2f55gslll5j3w">
                {featured.name}
              </h3>
              <p className="mt-5 text-[0.95rem] leading-[1.8] text-ink-soft" data-id="element-116" data-mp="2k51lyo60rgl1">
                {featured.description}
              </p>
              <div className="mt-auto flex items-center justify-between gap-4 pt-8" data-id="element-117" data-mp="2747osyk04c3o">
                <span className="text-xs text-ink-muted" data-id="element-118" data-mp="2m185m70nmmnd">{featured.duration}</span>
                <a href="#consultation" className="flex items-center gap-2 text-xs uppercase tracking-overline text-ink transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-119" data-mp="2h1lsdxktt6ek">
                  Learn more
                  <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-120" data-mp="2q20hl80wv5nc" />
                </a>
              </div>
            </div>
          </article>

          {rest.map(procedure => <article key={procedure.name} className="group flex flex-col bg-white" data-id="element-121" data-mp="2zsvcf0s83dke">
              <div className="overflow-hidden" data-id="element-122" data-mp="3dse98xfl32he">
                <img src={procedure.image} alt={procedure.name} className="h-56 w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.03]" data-id="element-123" data-mp="39qj9hxdawx5q" />
              </div>
              <div className="flex flex-1 flex-col p-7" data-id="element-124" data-mp="17h8zhq8lxc7">
                <span className="text-[0.6rem] uppercase tracking-overline text-champagne-dark" data-id="element-125" data-mp="3jeokps5hlmgl">
                  {procedure.category}
                </span>
                <h3 className="mt-4 text-xl font-normal tracking-[-0.01em] text-ink" data-id="element-126" data-mp="3oet1ljab4j7c">
                  {procedure.name}
                </h3>
                <p className="mt-3 text-[0.9rem] leading-[1.75] text-ink-soft" data-id="element-127" data-mp="3ef25jd63lw55">
                  {procedure.description}
                </p>
                <div className="mt-auto flex items-center justify-between gap-4 pt-6" data-id="element-128" data-mp="30p8f4qey33tb">
                  <span className="text-xs text-ink-muted" data-id="element-129" data-mp="34pikc0uwxq74">{procedure.duration}</span>
                  <a href="#consultation" className="flex items-center gap-1.5 text-[0.7rem] uppercase tracking-overline text-ink transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-130" data-mp="2qqiwuwj4zhcj">
                    Details
                    <ArrowUpRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-131" data-mp="3u16ij97the34" />
                  </a>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}